import { GenerateSection } from './components/GenerateSection'
import { InfoSection } from './components/InfoSection'
import { ValidateSection } from './components/ValidateSection'

export const Main = () => (
  <main>
    <GenerateSection />

    <ValidateSection />

    <InfoSection />
  </main>
)
